import { defineComponent, PropType } from "vue";

type ClickHouseProgress = {
    readRows: number;
    totalRowsToRead?: number;
    rowsPerSecond?: number;
};

export type LogSearchProgressState = {
    nonce: string;
    stage: string;
    clickhouse?: ClickHouseProgress;
    count?: number;
};

const ProgressLabels: Record<string, string> = {
    starting    : "Préparation de la recherche…",
    ack         : "Recherche reçue par le serveur…",
    searching   : "Recherche des logs en cours…",
    resolving   : "Résolution des utilisateurs et salons…",
    timeout     : "Recherche arrêtée: délai dépassé.",
    error       : "Erreur pendant la recherche.",
};

function formatCompactNumber(value: number) {
    return Intl.NumberFormat("fr-FR", {
        notation: "compact",
        maximumFractionDigits: 1,
    }).format(value);
}

export const LogSearchProgress = defineComponent({
    props: {
        progress: {
            type: Object as PropType<LogSearchProgressState | null>,
            default: null,
        },
        oncancel: {
            type: Function as PropType<() => void>,
            required: true,
        },
    },

    setup(props) {
        return () => {
            const progress = props.progress;

            if (!progress || progress.stage === "done")
                return null;

            const isFinished = progress.stage === "timeout" || progress.stage === "error";

            return (
                <div class={{
                    "log-search-progress"           : true,
                    "log-search-progress--finished" : isFinished,
                }}>
                    {!isFinished && <span class="log-search-progress__spinner" aria-hidden="true" />}
                    {isFinished && <span class="material-symbols-outlined">error</span>}
                    <span class="log-search-progress__label">{ProgressLabels[progress.stage] || "Recherche en cours…"}</span>
                    {progress.clickhouse && (
                        <span class="log-search-progress__details">
                            {formatCompactNumber(progress.clickhouse.readRows)} lignes lues
                            {progress.clickhouse.totalRowsToRead ? ` / ${formatCompactNumber(progress.clickhouse.totalRowsToRead)}` : ""}
                            {progress.clickhouse.rowsPerSecond ? ` · ${formatCompactNumber(progress.clickhouse.rowsPerSecond)}/s` : ""}
                        </span>
                    )}
                    {Number.isFinite(progress.count) && (
                        <span class="log-search-progress__count">{progress.count} logs</span>
                    )}
                    {!isFinished && (
                        <button type="button" onClick={props.oncancel}>Annuler</button>
                    )}
                </div>
            );
        };
    },
});
